module.exports = __webpack_public_path__ + "imgs/evelyn-lachapelle.8fea5ded265ca5f02d6e3ba07cc63be6.jpg";